'use strict';

/**
 *  Module
 *
 * Description 辅助写作模块
 * Author: wang.jiang 2016-2-17
 */
angular
    .module('editctrSupportCreationModule', [
        'supportCreationAlertDetailModule',
        'scSensitiveWordCheckModule',
        'scTrsCheckModule',
        'scPersonalMaterialModule',
        'topicExtensionModule',
        'intelligencePicModule',
        'docBackgroundModule',
        'scrollFixLocalDirModule',
        'onlineSearchModule',
        'loadingPromptDirectiveModule',
        'locationListDirectiveModule',
    ])
    .directive('supportCreation', [
        '$timeout',
        'messagePublishService',
        'publicToolService',
        function ($timeout, messagePublishService, publicToolService) {
            return {
                // name: '',
                // priority: 1,
                // terminal: true,
                scope: {
                    // content: "=",
                    isNews: '@', // 判断是否是新闻稿，非新闻稿没有 个人素材，主题延展，稿件背景的功能
                    isTrsCheckMenu: '@', // 是否有错别字校对
                    toggleSidebar: '@', // 改变侧边的宽度
                    hasEditor: '@',
                    list: '=',
                    isCheckSensitiveWords: '=', // 判断是否校验敏感词
                    mediaType: '@',
                    parentStatus: '=', // 获取父scope的status属性
                    bigFaceSwitch: '=', // 大花脸开关
                    noOpenCreation: '=', // 不打开创作轴
                }, // {} = isolate, true = child, false/undefined = no change
                // controller: function($scope, $element, $attrs, $transclude) {},
                // require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
                restrict: 'E', // E = Element, A = Attribute, C = Class, M = Comment
                // template: '',
                templateUrl: './editingCenter/directive/supportCreation/template/support_creation_tpl.html',
                replace: true,
                // transclude: true,
                // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
                link: function ($scope, iElm, iAttrs) {
                    init();
                    listenClearMarkHeimaWords();
                    listenShowTrsCheck();

                    /**
                     * [init description] 初始化
                     * @return  {[type]}  [return description]
                     */
                    function init() {
                        $scope.status = {
                            // 新增start
                            sidebar: '',
                            // end
                            page: {},
                            message: {},
                            sensitiveWordCheck: false,
                            trsCheck: false,
                            bigFaceSwitch: false,
                            // heimaPlatform: $stateParams.status === '1' || $stateParams.wzplatform === '1' || $stateParams.appplatform === '1' || $stateParams.newspapertype === '2' || $stateParams.wxplatform === "1"
                            heimaPlatform: true,
                            openStatus: Boolean($scope.noOpenCreation), // 默认打开创作轴
                        };
                        publicToolService.getModeconfiguration('supportCreation').then((config) => {
                            $scope.status.isShow = config;
                            for (let i in $scope.status.isShow) {
                                if ($scope.status.isShow[i]) {
                                    if (i !== 'wenzhangjiaodui') { // 针对文章校对单独处理
                                        $scope.changeSidebar(i);   
                                    } else {
                                        $scope.status.openStatus = true;
                                        $scope.toggleStatus();
                                    }
                                    break;
                                }
                            }
                            if ($scope.isNews === 'true') {
                                $('.body_manuscript_content')
                                    .addClass('bigWidth')
                                    .removeClass('smallWidth');
                            } else {
                                $('.body_manuscript_content')
                                    .addClass('smallWidth')
                                    .removeClass('bigWidth');
                            }
                            // 禁止拖拽变量初始化
                            $timeout(function () {
                                $scope.notAllowDragPic = !(iAttrs.notAllowDragPic === 'false' || iAttrs.notAllowDragPic === undefined);
                                $scope.notAllowDragVideo = !(iAttrs.notAllowDragVideo === 'false' || iAttrs.notAllowDragVideo === undefined);
                                $scope.notAllowDragAudio = !(iAttrs.notAllowDragAudio === 'false' || iAttrs.notAllowDragAudio === undefined);
                            });
                            // 新增
                            $scope.data = {};
                        });
                    }

                    /**
                     * [getEditorHeight description]初始化获取编辑器区域的高度并设置辅助编辑的高度
                     * @return {[type]} [description]
                     */
                    $scope.getEditorHeight = function () {
                        if ($scope.hasEditor) {
                            var editorHeight = $('.body_manuscript_editor').outerHeight();
                            $('.switch_content').height(editorHeight);
                            $('.switch_content').css({ overflowY: 'hidden!important' });
                        }
                    };
                    // 新增
                    /**
                     * [initOrigin description]切换侧边按钮
                     * @param   {[type]}  type  [type description]
                     * @return {[type]} [description]
                     */
                    $scope.changeSidebar = function (type) {
                        openSupportCreation();
                        delete $scope.status.sidebar;
                        // 重置其他按钮的状态
                        if (angular.isDefined($scope.bigFaceSwitch)) {
                            $scope.bigFaceSwitch.status = false;
                        }
                        $scope.status.sensitiveWordCheck = $scope.status.trsCheck = false;
                        $('.body_manuscript_content')
                            .addClass('bigWidth')
                            .removeClass('smallWidth');
                        $timeout(function () {
                            $scope.status.sidebar = type;
                        }, 100);
                    };
                    // end

                    /**
                     * [sensitiveWordCheck description]敏感词校验
                     * @param   {[type]}  type  [type description]
                     * @return  {[type]}        [return description]
                     */
                    $scope.sensitiveWordCheck = function (type) {
                        if ($scope.bigFaceSwitch && $scope.bigFaceSwitch.status) {
                            return;
                        } // 如果查看痕迹打开了，不能直接切换到敏感词校验
                        delete $scope.status.sidebar;
                        $scope.status.sensitiveWordCheck = !$scope.status.sensitiveWordCheck;
                        if (!$scope.status.sensitiveWordCheck) {
                            // $scope.status.sidebar = 'chuangzuozhou';
                            if ($scope.toggleSidebar && $scope.hasEditor) {
                                // 需要收起展开侧边栏并且有编辑器
                                $('.body_manuscript_content')
                                    .addClass('smallWidth')
                                    .removeClass('bigWidth');
                            }
                        } else {
                            $scope.status.sidebar = type;
                            $scope.status.trsCheck = false; // 重置错别字校对和查看痕迹的状态
                            if (angular.isDefined($scope.bigFaceSwitch)) {
                                $scope.bigFaceSwitch.status = false;
                            }
                            if ($scope.hasEditor) {
                                // 有编辑器则需要展开敏感词校验
                                $('.body_manuscript_content')
                                    .addClass('bigWidth')
                                    .removeClass('smallWidth');
                            }
                        }
                    };

                    /**
                     * [viewEditTraces description] 错别字校对
                     * @param   {[type]}  type  [type description]
                     * @return {[type]} [description]
                     */
                    $scope.trsCheck = function (type) {
                        $scope.status.openStatus = $scope.status.trsCheck;
                        $scope.toggleStatus();
                        // openSupportCreation();
                        if ($scope.bigFaceSwitch && $scope.bigFaceSwitch.status) {
                            return;
                        } // 如果查看痕迹打开了，不能直接切换到错别字校验
                        delete $scope.status.sidebar;
                        $scope.status.trsCheck = !$scope.status.trsCheck;
                        if (!$scope.status.trsCheck) {
                            $scope.isTrsCheckFromSave = false;
                            
                            // $scope.status.sidebar = 'chuangzuozhou';
                            if ($scope.toggleSidebar && $scope.hasEditor) {
                                // 需要收起展开侧边栏并且有编辑器
                                $('.body_manuscript_content')
                                    .addClass('smallWidth')
                                    .removeClass('bigWidth');
                            }
                        } else {
                            $scope.status.sidebar = type;
                            if (angular.isDefined($scope.bigFaceSwitch)) {
                                $scope.bigFaceSwitch.status = false;
                            }
                            $scope.status.sensitiveWordCheck = false; // 重置错别字校对和查看痕迹的状态
                            if ($scope.hasEditor) {
                                // 有编辑器则需要展开敏感词校验
                                $('.body_manuscript_content')
                                    .addClass('bigWidth')
                                    .removeClass('smallWidth');
                            }
                        }
                    };

                    /**
                     * [listenClearMarkHeimaWords 监听取消校对的动作，用于保存时]
                     *
                     * @return  {[type]}  [return description]
                     */
                    function listenClearMarkHeimaWords() {
                        messagePublishService.subscribe(
                            'clearMarkHeimaWord',
                            function () {
                                $scope.status.trsCheck = !$scope.status.trsCheck;
                                if (!$scope.status.trsCheck) {
                                    // $scope.status.sidebar = 'chuangzuozhou';
                                    if ($scope.toggleSidebar && $scope.hasEditor) {
                                        // 需要收起展开侧边栏并且有编辑器
                                        $('.body_manuscript_content')
                                            .addClass('smallWidth')
                                            .removeClass('bigWidth');
                                    }
                                }
                            },
                            $scope
                        );
                    }

                    /**
                     * [listenShowTrsCheck 监听文章校对状态]
                     * @return  {[type]}  [return description]
                     */
                    function listenShowTrsCheck() {
                        messagePublishService.subscribe(
                            'trsCheck',
                            function (e, data) {
                                $scope.status.trsCheck = data.isTrsCheck;
                                if (!$scope.status.trsCheck) {
                                    // $scope.status.sidebar = 'chuangzuozhou';
                                    if ($scope.toggleSidebar && $scope.hasEditor) {
                                        // 需要收起展开侧边栏并且有编辑器
                                        $('.body_manuscript_content')
                                            .addClass('smallWidth')
                                            .removeClass('bigWidth');
                                    }
                                } else {
                                    $scope.status.sidebar = 'trsCheck';
                                    $scope.isTrsCheckFromSave = true;
                                    $scope.subHeimaWordsArr = data.heimaInfo;
                                }
                            },
                            $scope
                        );
                    }

                    /**
                     * [viewEditTraces description] 查看痕迹
                     * @return {[type]} [description]
                     */
                    $scope.viewEditTraces = function () {
                        openSupportCreation();
                        if ($scope.status.sidebar === 'sensitiveWordCheck' || $scope.status.sidebar === 'trsCheck') {
                            return;
                        } // 如果敏感词校验或错别字校验打开了，不能直接切换到查看痕迹
                        delete $scope.status.sidebar;
                        var ue = UE.getEditor('ueditor');
                        if (!$scope.bigFaceSwitch.status) {
                            $timeout(function () {
                                $scope.bigFaceSwitch.status = true;
                                $scope.status.sidebar = 'viewEditTraces';
                                $scope.status.trsCheck = $scope.status.sensitiveWordCheck = false; // 重置错别字校对和查看痕迹的状态
                                $('.body_manuscript_content')
                                    .addClass('smallWidth')
                                    .removeClass('bigWidth');
                                $('.editorContainer135').addClass('bigFace135');
                                ue.setDisabled();
                            });
                        } else {
                            $scope.status.sidebar = 'chuangzuozhou';
                            $timeout(function () {
                                $scope.bigFaceSwitch.status = false;
                                if ($scope.isNews) {
                                    $('.body_manuscript_content')
                                        .addClass('bigWidth')
                                        .removeClass('smallWidth');
                                }
                                ue.setEnabled();
                                $('.editorContainer135').removeClass('bigFace135');
                            });
                        }
                    };
                    $scope.$watch('status.sidebar', function (newV, oldV) {
                        if (oldV === 'viewEditTraces' && newV !== 'viewEditTraces') {
                            $timeout(function () {
                                $scope.bigFaceSwitch.status = false;
                            });
                        }
                    });

                    /**
                     * [initDivHeight description] 初始化div高度
                     * @return  {[type]}  [return description]
                     */
                    $scope.initDivHeight = function () {
                        var height = (iElm.parents('.body_right_iWo').outerHeight(!0) ? iElm.parents('.body_right_iWo').outerHeight(!0) : iElm.parents('.body_right_jingjian').outerHeight(!0)) + 'px';
                        return height;
                    };

                    /**
                     * [toggleStatus description] 切换状态
                     * @return  {[type]}  [return description]
                     */
                    $scope.toggleStatus = function () {
                        toggleStatus();
                    };

                    /**
                     * [toggleStatus description] 切换状态
                     * @return  {[type]}  [return description]
                     */
                    function toggleStatus() {
                        var Element = iElm;
                        $scope.status.openStatus ? (Element.removeClass('creation__open').addClass('creation__close'),
                        $('.editPage').removeClass('creation__show').addClass('creation__hide')) : (Element.removeClass('creation__close').addClass('creation__open'),
                        $('.editPage').removeClass('creation__hide').addClass('creation__show'));
                        $scope.status.openStatus = !$scope.status.openStatus;
                    }

                    /**
                     * [openSupportCreation description] 打开创作轴
                     * @return  {[type]}  [return description]
                     */
                    function openSupportCreation() {
                        if (!$scope.status.openStatus) {
                            toggleStatus();
                        }
                    }
                },
            };
        },
    ]);
